import { getHeaders } from "./getHeaders";
import { API_URL } from "./constants";
import { TRequestOptions } from "./types";

type TResult = {
  response: any;
  ok: boolean;
  status: number;
  data: any;
  parsedError?: any;
};

/**
 • Рекурсивная функция для замены строки "null" на реальный null
 */
const mapStringNull = (data: any): any => {
  // Если это строка "null"
  if (data === "null") {
    return null;
  }

  // Если это массив, проходим по каждому элементу
  if (Array.isArray(data)) {
    return data.map(mapStringNull);
  }

  // Если это объект (не null и не массив)
  if (data !== null && typeof data === "object") {
    const nextData: any = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        nextData[key] = mapStringNull(data[key]);
      }
    }
    return nextData;
  }

  // Для всех остальных типов (числа, булевы значения, уже настоящие null)
  return data;
};

export const request = async (options: TRequestOptions) => {
  let {
    path,
    body = null,
    method = "GET",
    headers,
    requestType = "json",
    responseType = "json",
    callback,
  } = options;

  let commonHeaders = await getHeaders(requestType);

  if (headers) {
    commonHeaders = { ...commonHeaders, ...headers };
  }

  const requestConfig = {
    method,
    body,
    headers: commonHeaders,
  };

  let response: any;
  try {
    response = await fetch(
      `${process.env.REACT_APP_API_URL}/${path}`,
      requestConfig,
    );
  } catch (e) {
    if (typeof callback === "function") {
      callback();
    } else {
      console.log(e);
    }
  }

  let result: TResult = {
    response,
    ok: !!response?.ok,
    status: response?.status,
    data: null,
    parsedError: null,
  };

  if (response?.status === 401) {
    alert("Authorize error, please login again");
  }

  if (response?.ok) {
    try {
      if (responseType === "json") {
        result.data = await response.json();
      } else if (responseType === "text") {
        result.data = await response.text();
      } else if (responseType === "blob") {
        result.data = await response.blob();
      }
    } catch (e) {
      console.error("Parse error", e);
    }
  } else if (response) {
    let errorBody = null;
    try {
      errorBody = await response.json();
    } catch (e) {
      try {
        errorBody = await response.text();
      } catch (err) {}
    }
    result.data = errorBody;
  }

  // --- МАППИНГ ЗНАЧЕНИЙ "null" -> null ---
  if (result.data !== null && responseType === "json") {
    result.data = mapStringNull(result.data);
  }

  console.log("result", result);
  return result;
};